import React, { Component } from 'react'
import { login } from '../fetch-utils';

export default class Login extends Component {
    state = {
        email: '',
        password: '',
    }

    handleSubmit = async e => {
        e.preventDefault();
        const token = await login(this.state.email, this.state.password);

        this.props.login(token)
        console.log(this.state)
        this.props.history.push('/')
    }

    handleEmailChange = e => {
        this.setState({ email: e.target.value });
    }

    handlePasswordChange = e => {
        this.setState({ password: e.target.value });
    }

    render() {
        return (
            <div className="auth-style">
                <form onSubmit={this.handleSubmit}>
                    <div className="auth-box">
                        <div>
                            <label>
                                Email
                                <input type='email' onChange={this.handleEmailChange}/>
                            </label>
                        </div>
                        <div>
                            <label>
                                Password
                                <input type='password' onChange={this.handlePasswordChange}/>
                            </label>
                        </div>
                        <div>
                            <button className="login-button">Login</button>
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}
